export const blockIconsTransportationElectricBikeNew = (
	<span className='material-symbols-outlined'>electric_bike</span>
);
